import React, { useEffect, useState, Fragment } from 'react';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';

export const ReSyncTransactionListing = ({ fieldFilteringData, handleClick }) => {

    const [fieldFiltering, setFieldFiltering] = useState([]);
    const contentRowNames = ["date", "divisionID", "failedCount"]
    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "date" ?
                (<td key={index}>{da[row].split("T")[0]}</td>)
                : <td key={index}>{da[row] + " "}</td>
            )

        )
    });

    useEffect(() => {
        trackPromise(
            setFieldFilteringData()
        )
    }, [fieldFilteringData]);

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    async function setFieldFilteringData() {
        destroyDataTable();
        await setFieldFiltering(fieldFilteringData);
        createDataTable();
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <hr />
                        <div className="table-responsive row-top-gap">
                            <table id="example" className="display dataTable no-footer">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Division</th>
                                        <th>Failed Transactions</th>
                                        <th>Resync</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {fieldFiltering.map((data, i) => {
                                        return (
                                            <tr key={i}>
                                                {content(data)}
                                                <td onClick={() => handleClick(data)} style={{ cursor: "pointer" }}><i class='fas fa-sync'></i></td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}


